import { useEffect, useState } from "react";
import ThemeToggle from "@/components/portfolio/ThemeToggle";

const items = [
  { id: "work", label: "Work" },
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "clients", label: "Clients" },
  { id: "contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (!el) return;
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(el, { offset: -40, duration: 1.2 });
    else el.scrollIntoView({ behavior: "auto", block: "start" });
  };

  return (
    <header data-testid="site-nav" className={`site-nav ${scrolled ? "is-scrolled" : ""}`}>
      <a
        href="#top"
        onClick={go("top")}
        className="nav-mark"
        data-testid="nav-logo"
      >
        <span className="nav-mark__index">D/J</span>
        <span className="nav-mark__name">Deepanshu Jha</span>
      </a>

      <button className="nav-menu chip" type="button" aria-expanded={menuOpen} aria-controls="primary-navigation" onClick={() => setMenuOpen(value => !value)}>Menu</button>
      <nav id="primary-navigation" className={`nav-links ${menuOpen ? "nav-links--open" : ""}`} aria-label="Primary" onKeyDown={(event) => { if (event.key === "Escape") { setMenuOpen(false); event.currentTarget.previousElementSibling.focus(); } }}>
        {items.map((it) => (
          <a
            key={it.id}
            href={`#${it.id}`}
            onClick={go(it.id)}
            data-testid={`nav-${it.id}-link`}
            className="nav-link"
          >
            {it.label}
          </a>
        ))}
      </nav>

      <div className="nav-right">
      <a
        href="#contact"
        onClick={go("contact")}
        className="nav-cta"
        data-testid="nav-hire-cta"
      >
        <span>Hire me</span>
        <i className="dot" aria-hidden />
      </a>
      <ThemeToggle />
      </div>
    </header>
  );
}
